/**
 * @module teaser-outer
 * @listens filter:{group}:filter-changed
 * @requires S.filter
 */
S.projectFilter =
    {
        $module: null,

        config: {
            group: '',
        },

        elements: {
            $teaser: null,
        },

        entries: [],
        filterEventName: null,
        filter: null,

        init()
        {
            this.initializeFilterEntries();
        },

        /**
         * 'filter:{group}:filter-changed'. The event could have been fired long before the module initialization.
         * @private
         */
        initializeFilterEntries()
        {
            if (!S.filter || !S.filter.instances)
            {
                return S.delayed('', 1000, () =>
                {
                    this.initializeFilterEntries();
                });
            }

            $.each(S.filter.instances, (i, instance) =>
            {
                if (instance.config.group === this.config.group)
                {
                    this.filter = instance.filter;
                    this.filterEventName = instance.getEventName();
                }
            });
            this.handleChangedEntries(this.filter);
            this.listen();
        },

        listen()
        {
            if (this.filterEventName)
            {
                $(document).bind(this.filterEventName, (e, data) =>
                {
                    // console.log('S.projectFilter.listen() on ' + this.filterEventName + ' data', data);
                    this.handleChangedEntries(data.filter);
                });
            }
        },

        /**
         * @param {Array.<String>} data
         */
        handleChangedEntries(data)
        {
            if (data.length === 0)
            {
                this.elements.$teaser.removeClass('is-hidden');

                return;
            }

            const dataGroups = this.groupData(data);

            // Loop through each teaser, run the filter check, and display or hide item
            this.elements.$teaser.each((i, item) =>
            {
                const $item = $(item);
                const found = this.itemMatchesToDataGroups($item, dataGroups);

                if (found)
                {
                    $item.removeClass('is-hidden');
                    // on load m-main visible
                    this.$module.find('.m-main').removeClass('is-hidden-onload');
                }
                else
                {
                    $item.addClass('is-hidden');
                }
            });
        },

        /**
         * @private
         * @param {Array.<String>} data
         * @return {Object}
         */
        groupData(data)
        {
            const dataGroup = {};

            $.each(data, (i, item) =>
            {
                const group = item.split('__')[0];

                if ($.type(dataGroup[group]) === 'undefined')
                {
                    dataGroup[group] = [];
                }
                dataGroup[group].push(item);
            });

            return dataGroup;
        },

        /**
         * @private
         * @param {jQuery} item
         * @param {Object} dataGroups
         * @return {Boolean}
         */
        itemMatchesToDataGroups(item, dataGroups)
        {
            const type = String(item.data('type'));
            const types = type ? type.split(',') : [];
            let found = true;

            // Loop through groups and check types against group entries, with following rules:
            // - Or condition within a group
            // - And condition between groups
            $.each(dataGroups, (p, items) =>
            {
                // Check, if entry is in group item
                found = items.some((item) =>
                {
                    return types.indexOf(item) > -1;
                });
                // console.log('S.projectFilter.itemMatchesToDataGroups()', {type: type, items: items.join(','), found: found});

                // Exit the loop, if the group item was not found
                if (found === false)
                {
                    return false;
                }
            });

            return found;
        },
    };
